
import { computed, defineComponent, ref } from 'vue'
import { EmployeeRouteNames } from '@/router/routes-names'
import EmployeesList from '@/components/employees/employees-list.vue'
import { useEmployeeModule } from '@/modules/employees'
import { useRoute, useRouter } from 'vue-router'
import { FormModelCacheTag, restoreFormModelTo, storeFormModel } from '@/modules/_shared/forms'
import { SimpleSearchFilter } from '@/views/_shared/search-list/types'

export default defineComponent({
    name: 'view-employees-employees',
    components: { EmployeesList },
    props: {
        restoreFilters: {
            type: [Boolean, String]
        }
    },
    async setup (props) {
        const route = useRoute()
        const { loadEmployees, employees } = useEmployeeModule()
        try {
            await loadEmployees()
        } catch (error) {}

        const employeesRows = computed(() => {
            return employees.value.map((employee) => {
                return {
                    ...employee,
                    isActive: !employee.isBlocked
                }
            })
        })

        const restoredFilter = { value: '' } as SimpleSearchFilter
        if (props.restoreFilters) {
            restoreFormModelTo(restoredFilter, FormModelCacheTag.EMPLOYEES_LIST_FILTERS)
        }

        const filter = ref<string>(restoredFilter.value ?? '')

        const filteredEmployees = computed(() => {
            storeFormModel({ value: filter.value }, FormModelCacheTag.EMPLOYEES_LIST_FILTERS)

            if (filter.value === null || filter.value === '') {
                return employeesRows.value
            }

            const regexp = new RegExp(filter.value, 'i')
            return employeesRows.value.filter(employee => regexp.test(`${employee.firstName} ${employee.lastName} ${employee.email} ${employee.id} ${employee.roles.map(role => role.name).toString()}`))
        })
        return {
            routeNames: EmployeeRouteNames,
            filteredEmployees,
            filter,
            route
        }
    }
})
